import type { FormRestrictionStatus } from '@atlassian/proforma-form-security';

export const UpdateFormVisibilityResult = {
	SUCCESS: 'Success',
	CANCELLED: 'Cancelled',
	FAILURE: 'Failure',
};

export type HandleUpdateFormVisibility = (
	formId: number,
	toInternal: boolean,
	formRestrictionStatus?: FormRestrictionStatus,
) => Promise<(typeof UpdateFormVisibilityResult)[keyof typeof UpdateFormVisibilityResult]>;
